import { useState } from 'react';

import { IconButton } from '@/shared/ui/lib/IconButton';

import { ListItemText, Menu, MenuItem as MuiMenuItem } from '../index';
import { SvgIcon } from '../SvgIcon';

type MenuItem = {
  label: string;
  onClick: () => void;
  color?: 'error' | 'default';
};

export interface IMenuButtonProps {
  menuItems: MenuItem[];
  disabled?: boolean;
}

export const SettingMenuButton = ({
  menuItems,
  disabled,
}: IMenuButtonProps) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleMenuItemClick = (onClick: () => void) => {
    onClick();
    handleMenuClose();
  };

  return (
    <>
      <IconButton
        onClick={handleMenuOpen}
        disabled={disabled}
        size="small"
        variant="icon"
      >
        <SvgIcon name="setting-icon" />
      </IconButton>

      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleMenuClose}
        onClick={handleMenuClose}
      >
        {menuItems.map((item, index) => (
          <MuiMenuItem
            /* eslint-disable-next-line react/no-array-index-key */
            key={index}
            onClick={() => handleMenuItemClick(item.onClick)}
            sx={item.color === 'error' ? { color: 'error.main' } : undefined}
          >
            <ListItemText>{item.label}</ListItemText>
          </MuiMenuItem>
        ))}
      </Menu>
    </>
  );
};
